import { render, staticRenderFns } from "./FileUploadAlert.vue?vue&type=template&id=0f5b7c37&scoped=true&"
import script from "./FileUploadAlert.vue?vue&type=script&lang=js&"
export * from "./FileUploadAlert.vue?vue&type=script&lang=js&"
import style0 from "./FileUploadAlert.vue?vue&type=style&index=0&id=0f5b7c37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5b7c37",
  null
  
)

export default component.exports